import { render } from "./icon-money-fill.vue?vue&type=template&id=0eb92c79"
import script from "./icon-money-fill.vue?vue&type=script&lang=js"
export * from "./icon-money-fill.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__